import gql from "graphql-tag";

export const GENERATE_API_TOKEN = gql`
  mutation GenerateApiToken($data: CreatePatInput!) {
    generateApiToken(data: $data) {
      id
      name
      prefix
      scopes
      lastUsedAt
      expiresAt
      createdAt
      rawToken
    }
  }
`;

export const REVOKE_API_TOKEN = gql`
  mutation RevokeApiToken($tokenId: String!) {
    revokeApiToken(tokenId: $tokenId)
  }
`;

export const LIST_API_TOKENS = gql`
  query ListApiTokens {
    listApiTokens {
      id
      name
      prefix
      scopes
      lastUsedAt
      expiresAt
      revokedAt
      createdAt
    }
  }
`;
